
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/webcam",
      function () {
        return require("private-next-pages/[region]/webcam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/webcam"])
      });
    }
  